import React  from 'react';
import PropTypes from 'prop-types';
import { ServicesIconElement } from '../elements/ServicesIconElement';
import { Heading } from '../elements/Heading';
import { BackButton } from '../../elements';

export const ServicesIconsComponent = (props) => {
  const {content} = props;
	return(
		<section className="col-12 kiwi-services--icon">
			<div className="container">
				<div className="row">
				<BackButton	/>
					<div className="col-xs-12 text-center">
						<Heading size="h2" content={content.heading}/>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-8 col-xs-offset-2 text-center">
						<div className="row">
							<ul className="services--icon-list list-unstyled">

								{content.services.map((services, i) => {
								return (
									<li className="services--icon-list-item icon-list" key={i}>
										<ServicesIconElement key={i} text={services.text} image={services.image} button={services.button} color={content.color} textColor={content.textColor}/>
									</li>
									);
								})}

							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
};

ServicesIconsComponent.propTypes = {
	services: PropTypes.array,
	heading: PropTypes.string
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/components/ServicesIconsComponent.js